class RegulatoryDamageService {
  get_data(page, data) {
    return axios.post('general/regulatory-violation-damage?page=' + page, data)
  }
  get(id) {
    return axios.get('general/regulatory-violation-damage/' + id)
  }
  add(data) {
    return axios.post('general/regulatory-violation-damage/store', data)
  }
  edit(id, data) {
    return axios.post('general/regulatory-violation-damage/update/' + id, data)
  }
  delete(id) {
    return axios.delete('general/regulatory-violation-damage/delete/' + id)
  }

}
export default new RegulatoryDamageService();